import { render, staticRenderFns } from "./BodyAnatomyTypeCard.vue?vue&type=template&id=456c427e&"
import script from "./BodyAnatomyTypeCard.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports